import { t } from "i18next";
import axios from "axios";
import { useEffect, useState } from "react";
import { ShieldTick } from "iconsax-react";
import DBModal from "../../component/global/DBModal";
import DBButton from "../../component/global/DBButton";
import DBSpinner from "../../component/global/DBSpinner";
import { surveyActionUrl } from "../../helperData/ApiAddress";
import { SurveyFormRenderer, MultiStepSurveyFormRenderer } from "../../modules/form-builder";
import { SURVEY_FORM_DISPLAY_STEP } from "./constants";
import { RewardBadge } from "../../features/incentives/Rewards";
import "../SurveyResponse/style.scss";

export default function SurveyPreviewModal({ show, surveyId, onHide }) {
    const [definition, setDefinition] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!show || !surveyId) {
            setDefinition(null);
            setError(false);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setError(false);
        setDefinition(null);

        const auth = sessionStorage.getItem("auth");
        axios
            .get(surveyActionUrl(surveyId, "preview"), {
                headers: auth ? { Authorization: `Bearer ${auth}` } : {},
            })
            .then((r) => {
                if (!cancelled) setDefinition(r.data);
            })
            .catch(() => {
                if (!cancelled) setError(true);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [show, surveyId]);

    return (
        <DBModal
            permanent
            show={show}
            minWidth={640}
            onHide={onHide}
            className="survey-preview-modal"
        >
            <DBModal.Header
                closeBtn={onHide}
                title={t("survey.action.preview")}
            />
            <DBModal.Content>
                {loading || (!error && !definition) ? (
                    <DBSpinner tip={t("loading")} />
                ) : error ? (
                    <div className="survey-preview-error">
                        <p>{t("survey.preview.load.error")}</p>
                    </div>
                ) : (
                    <div className="survey-response-page survey-preview-inline">
                        <div className="survey-response-card">
                            <header className="survey-response-header">
                                <div className="survey-response-title-row">
                                    <h1>{definition.title}</h1>
                                    <RewardBadge
                                        action="survey_submit"
                                        targetType="survey"
                                        targetId={definition.id}
                                        opportunity={
                                            definition.incentive_opportunity
                                        }
                                    />
                                </div>
                                {definition.subject_title && (
                                    <span className="survey-response-subject">
                                        {definition.subject_title}
                                    </span>
                                )}
                                {definition.description && (
                                    <p>{definition.description}</p>
                                )}
                                {definition.anonymous_responses && (
                                    <div className="survey-response-anonymous">
                                        <ShieldTick size={18} />
                                        <span>
                                            {t(
                                                "survey.response.anonymous.notice"
                                            )}
                                        </span>
                                    </div>
                                )}
                                {!definition.anonymous_responses && (
                                    <p className="survey-wizard-help">
                                        {t("survey.features.help")}
                                    </p>
                                )}
                            </header>
                            {definition.form_display_mode ===
                            SURVEY_FORM_DISPLAY_STEP ? (
                                <MultiStepSurveyFormRenderer
                                    criteria={definition.criteria || []}
                                    replies={{}}
                                    readOnly
                                />
                            ) : (
                                <SurveyFormRenderer
                                    criteria={definition.criteria || []}
                                    replies={{}}
                                    readOnly
                                />
                            )}
                            {definition.consent_text && (
                                <div className="survey-response-consent">
                                    <span>
                                        {t("survey.response.consent")}:{" "}
                                        {definition.consent_text}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("survey.settings.help.close")}
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
